<template>
  <div class="page">
    <div class="lingbiao_bg-wrap">
      <img class="lingbiao_bg" src="../../assets/images/lingbiao_bg.png" alt="">
    </div>
    <div class="mianjian">
      <div class="mianjian_title">
        何种车辆可申领电子标
      </div>
      <div class="mianjian_content">指行驶证注册日期<span style="font-weight: bold">距今6年内</span>，属于<span style="font-weight: bold">9座以下非营运车辆</span>，2020年6月20日起全国范围内可在"12123"APP上申请领取电子标。
      </div>
    </div>
    <div class="condition">
      <div class="condition_title">
        办理流程
      </div>
      <div class="condition_content">
        车辆需处理完交通违章与罚款
      </div>
      <div class="condition_btn">
        <van-button class="lingbiao_btn lingbiao_btn-weizhang" :to="'/lingbiao/weizhang'" block>查询处理违章</van-button>
        <van-button class="lingbiao_btn lingbiao_btn-next" :to="'/lingbiao/doc'"  block>下一步</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {Button} from 'vant';
  export default {
    name: "lingBiaoIndex",
    components:{
      VanButton:Button,
    }
  }
</script>

<style lang="less" scoped>
  @import "../../assets/less/utils";
  .lingbiao_bg{
    width: 322px;
    height: 228.5px;
    display: block;
    float:right;
    &-wrap{
      width: 100%;
      height: auto;
      &::after{
        .clearfix();
      }
    }
  }

   .mianjian{
     margin-top: 26px;
     padding:0 37px;
     box-sizing: border-box;
     &_content{
       color:#585A57;
       font-size: 15px;
       line-height: 23px;
       text-align: center;
     }
   }

  .condition{
    padding:20px 0;
    margin-top: 43px;
    background: #F1F1F1;
    background: url("../../assets/images/lb_radius_bg.png") no-repeat top center;
    &_content{
      display: block;
      color:#585A57;
      font-size: 15px;
      font-weight: 500;
      line-height: 18px;
      text-align: center;
    }
  }
  .mianjian_title, .condition_title{
    color:#5B994F;
    font-size: 25px;
    font-weight: 400;
    line-height: 30px;
    padding-left:50px;
    background: url("../../assets/images/lingbiao_icon.png") no-repeat left center;
    background-size:21.5px 23.5px ;
    display:block;
    width: 150px;
    margin: 0 auto 24px;
  }

  .mianjian_title{
    width: 250px;
  }
  .lingbiao_btn{
    width: 145px;
    height: 44px;
    border-radius: 9999px;
    margin:20px auto 0;
    font-weight: 500;
    &-weizhang{
      border-color: #7EB375;
      color:#4A963C;
    }
    &-next{
      background: #7EB375;
      color:#FFF;
    }
  }
</style>
